import { render, staticRenderFns } from "./ListAlbumsHeaders.vue?vue&type=template&id=17b158e5&"
import script from "./ListAlbumsHeaders.vue?vue&type=script&lang=js&"
export * from "./ListAlbumsHeaders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports